export type PermissionMainType = "public" | "private";
export type PermissionSubType =
  | "mass_exposed"
  | "not_mass_exposed"
  | "externally_exposed"
  | "mass_and_externally_exposed";

export type FileScanStatus = "not_started" | "in_progress" | "done";

export const PermissionsLabelIds: Record<string, PermissionTypeDesc> = {
  "f83bdea2-feb6-4d28-89ea-12fd129982f5": {
    title: "Public site",
    level: "H",
    main: "public",
    sub_type: "not_mass_exposed",
  },
  "5268e044-f79d-499c-8514-c321ab95e88d": {
    title: "Private site",
    main: "private",
    sub_type: "not_mass_exposed",
    level: "L",
  },
  "1e96ab77-6ef7-4665-99f0-b05e276a484a": {
    title: "Public external site",
    main: "public",
    sub_type: "externally_exposed",
    level: "H",
  },
  "ea3e38d4-54ae-4012-802f-a06e7ab20c9d": {
    title: "Private external site",
    main: "private",
    sub_type: "externally_exposed",
    level: "M",
  },
  "8f45d3d8-a04e-42ff-9f63-8c2afcf82dcd": {
    title: "Private mass exposed site",
    main: "private",
    sub_type: "mass_exposed",
    level: "H",
  },
  "f3529e68-9014-462f-983f-2b9980c55362": {
    title: "Private mass exposed external site",
    main: "private",
    sub_type: "mass_and_externally_exposed",
    level: "H",
  },
};

type PermissionTypeDesc = {
  main: "private" | "public";
  sub_type: PermissionSubType;
  level: "H" | "M" | "L";
  title: string;
};

export type PermissionCounter = {
  id: string;
  type: PermissionTypeDesc;
  count: number;
  files_scan_status: FileScanStatus;
};

export type FilesScanItem = {
  label: {
    id: string;
    name: string;
    icon: string;
  };
  sites_count: number;
  files_count: number;
};

export const PermissionTypeHelper = {
  to_key: (
    main_type: PermissionMainType,
    sub_type: PermissionSubType
  ): string => {
    return main_type + "_" + sub_type;
  },
};
